import { LocalizedFilterOptions } from "../utils";
interface CustomerStoryFilterSliderFilterProps {
    subFilterName: string;
    subFilterDescription: string;
    active: boolean;
    updateFilterObject: (subFilterName: string) => void;
}

export const CustomerStoryFilterSliderFilter = ({
    subFilterName,
    subFilterDescription,
    active,
    updateFilterObject
}: CustomerStoryFilterSliderFilterProps) => {
    const localizedMap = LocalizedFilterOptions();
    const optionId = `filter-checkbox-${subFilterName.replace(/\s/g, "")}`;

    return (
        <div key={subFilterName} className="filter-slider-button-container">
            <h4>{localizedMap[subFilterName]}</h4>
            <div className="filter-slider-content">
                <p>{localizedMap[subFilterDescription]}</p>
                {/* Tech debt that should be fixed. See ldr/0012-jsx-a11y-strict.md for details. */}
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="switch" htmlFor={optionId}>
                    <input
                        type="checkbox"
                        id={optionId}
                        checked={active}
                        onClick={() => updateFilterObject(subFilterName)}
                    />
                    <span className="slider round" />
                </label>
            </div>
        </div>
    );
};
